import { Input, InputProps } from "antd";
import styles from "./index.module.css";

export const CustomInput = (props: InputProps & { ref?: any }) => {
  return (
    <Input {...props} className={props.className ? props.className + " " + styles.customInput : styles.customInput} />
  );
};
